import React from "react";
import "./footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        David Ng
      </a>

      <ul className="permalinks">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Expeirience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        {/* <a href="https://facebook.com">
          <FaFacebookF />
        </a> */}
        <a href="https://www.instagram.com/amptech_studio/">
          <FiInstagram />
        </a>
        <a href="https://gitlab.com/davidsao">
          <FaGithub />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; 2023 David Ng. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
